import React, { useState, useEffect } from "react";
import ExtensionPreviewModal from "./extendPreviewModal";

const ExtendInternshipModal = ({
  isOpen,
  onClose,
  applicant,
  onExtend,
  className = "",
}) => {
  const [newEndDate, setNewEndDate] = useState("");
  const [extensionReqDate, setExtensionReqDate] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  useEffect(() => {
    if (applicant) {
      setNewEndDate(applicant.internshipEndDate || "");
    }
  }, [applicant]);

  if (!isOpen || !applicant) return null;

  const handleExtend = () => {
    onExtend(newEndDate);
    setIsPreviewOpen(true);
  };

  // Function to format date to YYYY-MM-DD
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const year = date.getFullYear();
    const month = monthNames[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    return `${month} ${day}, ${year}`;
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div
          className={`bg-white py-8 px-14 rounded-lg shadow-lg w-2/5 ${className}`}
        >
          <h2 className="text-3xl font-bold underline text-center mb-4 text-green-700">
            Extend Internship Period
          </h2>
          <div className="pl-8 mt-8">
            <p className="text-lg">
              Applicant Name:{" "}
              <strong>{`${applicant.surname || ""} ${
                applicant.firstName || ""
              } ${applicant.otherNames || ""}`}</strong>
            </p>
            <p className="text-lg">
              Department Assigned:{" "}
              <strong>{applicant.internshipDepartment || ""}</strong>
            </p>
            <p className="text-lg">
              Supervisor Assigned:{" "}
              <strong>{applicant.internshipSupervisor || ""}</strong>
            </p>
            <p className="text-lg">
              Internship Start Date:{" "}
              <strong>
                {applicant.internshipStartDate
                  ? formatDate(applicant.internshipStartDate)
                  : "N/A"}
              </strong>
            </p>
            <p className="text-lg">
              Current Internship End Date:{" "}
              <strong>
                {applicant.internshipEndDate
                  ? formatDate(applicant.internshipEndDate)
                  : "N/A"}
              </strong>
            </p>
          </div>

          {/* Form to extend the internship */}
          <div className="mt-4">
            <label className="block text-base font-semibold text-gray-700">
              Choose New Internship End Date
            </label>
            <input
              type="date"
              className="mt-1 p-2 w-full border rounded-md font-semibold border-gray-300 focus:border-green-500"
              value={newEndDate}
              onChange={(e) => setNewEndDate(e.target.value)}
            />
            <label className="block text-base font-semibold mt-3 text-gray-700">
              Enter the applicant's extension request letter date
            </label>
            <input
              type="date"
              className="mt-1 p-2 w-full border rounded-md font-semibold border-gray-300 focus:border-green-500"
              value={extensionReqDate}
              onChange={(e) => setExtensionReqDate(e.target.value)}
            />
          </div>
          <div className="flex justify-end space-x-8 mt-6">
            <button
              className="bg-gray-500 rounded-[12px] font-semibold text-base p-2 px-10 text-white"
              onClick={onClose}
            >
              Close
            </button>
            <button
              className="bg-green-700 font-semibold rounded-[12px] text-base p-2 px-10 text-white"
              onClick={handleExtend}
            >
              Extend
            </button>
          </div>
        </div>
      </div>

      {/* Preview Modal for Extension Letter */}
      {isPreviewOpen && (
        <ExtensionPreviewModal
          isOpen={isPreviewOpen}
          applicantDetails={applicant}
          newEndDate={newEndDate}
          extensionReqDate={extensionReqDate}
          onClose={() => {
            setIsPreviewOpen(false);
            // fetchApplications();
          }}
        />
      )}
    </>
  );
};

export default ExtendInternshipModal;
